import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 130,
    damping: 28,
    restDelta: 0.001,
  });

  return <div data-testid="site-scroll-progress" aria-hidden="true" className="pointer-events-none fixed right-2 top-1/2 z-[70] h-20 w-[2px] -translate-y-1/2 overflow-hidden rounded-full bg-cream/35 mix-blend-difference sm:right-4 sm:h-28"><motion.div style={{ scaleY: progress }} className="absolute inset-0 origin-top bg-cream" /></div>;
};
